import React from "react";
import { container } from "@/utils/mobx";
import { Dialog } from "@/components/toolkit/Dialog";
import { Clickable } from "@/components/toolkit/Clickable";
import { AgentPaneStore } from "./store";
import { t } from "@/i18n";

export const SessionSettingsModal = container((props: {
    store: AgentPaneStore;
}) => {
    const { store } = props;
    const id = store.sessionSettingsId;
    if (!id) return null;

    const settings = store.tabSettingsFor(id);

    return (
        <Dialog title={t("agent_session_settings")} onClose={() => store.closeSessionSettings()}>
            <div className="agent_pane__session_settings">
                <div className="agent_pane__session_settings_section">
                    <div className="agent_pane__session_settings_label">{t("settings_claude_model")}</div>
                    <div className="agent_pane__session_settings_options">
                        {([
                            { id: "",           label: t("settings_claude_model_default") },
                            { id: "claude-sonnet-4-6", label: "Sonnet 4.6" },
                            { id: "sonnet",     label: "Sonnet" },
                            { id: "claude-opus-5-5", label: "Opus 5.5" },
                            { id: "opus",       label: "Opus" },
                            { id: "haiku",      label: "Haiku" },
                        ] as const).map(({ id: modelId, label }) => (
                            <Clickable key={modelId} onClick={() => store.updateSessionSettings(id, { model: modelId || null })}>
                                <button
                                    className={`agent_pane__session_settings_btn${(settings?.model ?? "") === modelId ? " agent_pane__session_settings_btn--active" : ""}`}
                                >
                                    {label}
                                </button>
                            </Clickable>
                        ))}
                    </div>
                </div>
                <div className="agent_pane__session_settings_section">
                    <div className="agent_pane__session_settings_label">{t("settings_claude_effort")}</div>
                    <div className="agent_pane__session_settings_options">
                        {([
                            { id: "",       label: t("settings_claude_effort_default") },
                            { id: "low",    label: t("settings_claude_effort_low") },
                            { id: "medium", label: t("settings_claude_effort_medium") },
                            { id: "high",   label: t("settings_claude_effort_high") },
                            { id: "max",    label: t("settings_claude_effort_max") },
                        ] as const).map(({ id: effortId, label }) => (
                            <Clickable key={effortId} onClick={() => store.updateSessionSettings(id, { effort: effortId || null })}>
                                <button
                                    className={`agent_pane__session_settings_btn${(settings?.effort ?? "") === effortId ? " agent_pane__session_settings_btn--active" : ""}`}
                                >
                                    {label}
                                </button>
                            </Clickable>
                        ))}
                    </div>
                </div>
            </div>
        </Dialog>
    );
}, AgentPaneStore);
